export enum ScreenName {
  CART = 'CART',
  IDLE = 'IDLE',
  LOGIN = 'LOGIN',
  PAYMENT = 'PAYMENT',
  INPUT_INFO = 'INPUT_INFO',
}
